module.exports = __webpack_public_path__ + "media/images/eyecatch-shortcut-opening-2b3dc1db26b3cd6b097e2f53afd13275.jpg";